import { Empty, Typography } from 'antd';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  html?: string;
}

function CustomWidget({ instance }: WidgetRenderProps<Config>) {
  const html = instance.config.html;
  if (!html) {
    return (
      <Empty
        description={
          <>
            <Typography.Text type="secondary">
              Empty custom widget. Edit settings to add content.
            </Typography.Text>
          </>
        }
      />
    );
  }
  return (
    <div style={{ height: '100%', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: html }} />
  );
}

export const customWidgetDef: WidgetDefinition<Config> = {
  type: 'custom',
  name: 'Custom',
  description: 'Free-form HTML content',
  icon: 'AppstoreAddOutlined',
  category: 'content',
  defaultTitle: 'Custom Widget',
  defaultConfig: { html: '' },
  minW: 2,
  minH: 2,
  defaultW: 4,
  defaultH: 4,
  component: CustomWidget,
  settingsSchema: {
    fields: [
      {
        key: 'html',
        label: 'HTML content',
        type: 'textarea',
        description: 'Sanitize on the server before storing.',
      },
    ],
  },
};
